import { render, staticRenderFns } from "./logfiles.vue?vue&type=template&id=3bc0d6c6&scoped=true&"
import script from "./logfiles.vue?vue&type=script&lang=js&"
export * from "./logfiles.vue?vue&type=script&lang=js&"
import style0 from "./logfiles.vue?vue&type=style&index=0&id=3bc0d6c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc0d6c6",
  null
  
)

export default component.exports